<template>

    <v-container v-if="groups" fluid>

      <im-page-title
        title="Listă Grupuri"
      />

      <im-group-toolbar
        :query.sync="query"
        @create="goToCreate"
      />

      <div class="ma-3">
        <v-progress-linear
          :indeterminate="querying"
          :color="querying ? 'primary' : 'grey'"
          rounded
        />
      </div>

      <im-group-list
        :groups="groups"
        :pagination.sync="pagination"
        @edit="goToEdit"
      />

    </v-container>

    <v-container v-else fluid class="fill-height">
      <v-row align="center" justify="center">
        <v-progress-circular indeterminate color="primary"/>
      </v-row>
    </v-container>

</template>


<script>

  import group_repository from '@/repositories/group-repository';

  export default {

    components: {
      'im-page-title':    () => import('@/components/ThePageTitle'),
      'im-group-toolbar': () => import('@/components/HotelGroups/GroupToolbar'),
      'im-group-list':    () => import('@/components/HotelGroups/GroupList')
    },

    data: () => ({
      groups: null,
      query: null,
      querying: false,
      pagination: {size: 10, page: 1}
    }),

    watch: {
      query: {
        handler: 'fetchGroupsDebounced',
        immediate: true
      },
      pagination: {
        handler: 'fetchGroups',
        immediate: false
      }
    },

    methods: {

      fetchGroupsDebounced: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchGroups()
      }, 300),

      async fetchGroups() {
        try {
          this.querying = true;
          this.groups = await group_repository.getHotelGroups(this.query, this.pagination, {});
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.querying = false;
        }
      },

      goToCreate() {
        this.$router.push(`/hotel-groups/create`);
      },

      goToEdit(group) {
        this.$router.push(`/hotel-groups/${group}`);
      }

    }
  }

</script>